@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.no-orders-body {
  background-color: @label-batch-status--no-orders--background-color;
}

.no-orders-message {
  padding: 50px;
  width: 700px;
  text-align: center;
}
